// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_UPDATE_VERSION_LIST,
} from './constants';

export function updateVersionList(filter) {
  return {
    type: CAR_DATA_MASTER_UPDATE_VERSION_LIST,
    filter: filter
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_UPDATE_VERSION_LIST:
      let aux = [...state.versionListOrigin];
      aux = aux.filter(version => (version.brand_id === action.filter.brand_id || action.filter.brand_id === null) && (version.model_id === action.filter.model_id || action.filter.model_id === null) )
      return {
        ...state,
        versionList: [...aux]
      };

    default:
      return state;
  }
}
